import XLSX from "xlsx";

/**
 * Helper genérico para exportar qualquer array de objetos ou matriz para .xlsx
 */
export function exportToExcel(
  data: any[],
  filename: string,
  sheetName: string = "Sheet1",
  columns?: { header: string; field: string }[]
) {
  let ws: XLSX.WorkSheet;

  if (columns && columns.length) {
    // Ordena campos pelas colunas e aplica headers customizados
    const rows = data.map((row) => {
      const out: Record<string, any> = {};
      for (const col of columns) {
        out[col.header] = row[col.field] ?? "";
      }
      return out;
    });
    ws = XLSX.utils.json_to_sheet(rows, {
      header: columns.map((c) => c.header),
    });
  } else {
    ws = XLSX.utils.json_to_sheet(data);
  }

  const wb = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(wb, ws, sheetName);

  const ts = new Date().toISOString().slice(0, 19).replace(/[T:]/g, "-");
  const name = filename.endsWith(".xlsx") ? filename : `${filename}_${ts}.xlsx`;
  XLSX.writeFile(wb, name);
}

/**
 * Exporta múltiplas planilhas em um único arquivo .xlsx
 */
export function exportMultiSheetExcel(
  sheets: { name: string; data: any[]; columns?: { header: string; field: string }[] }[],
  filename: string
) {
  const wb = XLSX.utils.book_new();
  for (const sheet of sheets) {
    let ws: XLSX.WorkSheet;
    if (sheet.columns && sheet.columns.length) {
      const rows = sheet.data.map((row) => {
        const out: Record<string, any> = {};
        for (const col of sheet.columns!) {
          out[col.header] = row[col.field] ?? "";
        }
        return out;
      });
      ws = XLSX.utils.json_to_sheet(rows, { header: sheet.columns.map((c) => c.header) });
    } else {
      ws = XLSX.utils.json_to_sheet(sheet.data);
    }
    XLSX.utils.book_append_sheet(wb, ws, sheet.name.substring(0, 31));
  }
  const ts = new Date().toISOString().slice(0, 19).replace(/[T:]/g, "-");
  const name = filename.endsWith(".xlsx") ? filename : `${filename}_${ts}.xlsx`;
  XLSX.writeFile(wb, name);
}
